export const STORAGE_KEY = "waas-user-settings";
export const ACTIVE_ORGANIZATION_STORAGE_KEY = "waas-active-organization-id";
/** Same value as storage key; readable by proxy for demo-expiry checks. */
export const ACTIVE_ORGANIZATION_COOKIE_NAME = ACTIVE_ORGANIZATION_STORAGE_KEY;
export const LOCATION_SELECTION_STORAGE_KEY = "waas-selected-location-id:";
export const IN_APP_MESSAGES_CUTOFF_STORAGE_KEY = "waas-messages-cutoff";
export const IN_APP_MESSAGES_SEEN_IDS_STORAGE_KEY = "waas-seen-message-ids";
